const api = typeof window === 'undefined' ? global.API : window.API

exports.refresh = async function () {

  const token = localStorage.getItem( "token" )

  if ( !token ) {
    return create()
  }

  // -----------------
  // Payload
  // -----------------
  const params = {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    }
  }

  return fetch( `${api}/access/`, params ).then( payload )

}

const create = exports.create = async function () {

  // -----------------
  // Payload
  // -----------------
  const params = {
    method: "POST",
    headers: {
      "content-type": "application/json"
    }
  }

  return fetch( `${api}/access/`, params ).then( payload )

}

exports.update = async function ( username, password ) {

  const token = localStorage.getItem( "token" )

  // -----------------
  // Payload
  // -----------------
  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( { username, password } )
  }

  return fetch( `${api}/access/`, params ).then( payload )

}

// ----------------------------
// Standard Response Handler
// ----------------------------
const payload = async ( res ) => {

  try {
    // Standard response
    const { meta, data } = await res.json()
    // Extract token
    const { token, ...rest } = data || {}
    // Persist for general availability
    if ( token ) {
      localStorage.setItem( "token", token )
    }
    // Filtered response
    return { meta, data: rest }

  } catch ( err ) {
    return {
      meta: {
        status: "Service unavailable",
        code: 503,
        message: err.message
      }
    }
  }

}